export const htmlEncode = (text) => {
  return (
    text
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;")
      .replace(/;/g, "&semi;")
      .replace(/:/g, "&colon;")
      .replace(/<\/?strong>/g, "elt;strongegt;")
      .replace(/<\/?p>/g, "elt;pegt;")
      .replace(/<\/?b>/g, "elt;bregt;")
      .replace(/<ol>/g, "elt;olegt;")
      .replace(/<li>/g, "elt;liegt;")
      .replace(/<\/li>/g, "elt;/liegt;")
      .replace(/<\/ol>/g, "elt;/olegt;")
      .replace(/<ul>/g, "ulegtesemiesemi;")
      .replace(/<\/ul>/g, "/ulegtesemiesemi;")
      .replace(/<em>/g, "emegtesemiesemi;")
      .replace(/<\/em>/g, "/emegtesemiesemi;")
      .replace(/eltesemi/g, "eltesemi;")
      .replace(/pegtesemi/g, "pegtesemi;")
      .replace(/eltesemiesemi/g, "eltesemiesemi;")
      .replace(/pegtesemiesemi/g, "pegtesemiesemi;")
      .replace(/eltesemiesemiesemi/g, "eltesemiesemiesemi;")
      .replace(/pegtesemiesemiesemi/g, "pegtesemiesemiesemi;")
      .replace(/eltesemiesemiesemiesemi/g, "eltesemiesemiesemiesemi;")
      .replace(/pegtesemiesemiesemiesemi/g, "pegtesemiesemiesemiesemi;")
      .replace(/eltesemiesemiesemiesemiesemi/g, "eltesemiesemiesemiesemiesemi;")
      .replace(
        /pegtesemiesemiesemiesemiesemi/g,
        "pegtesemiesemiesemiesemiesemi;"
      )
      .replace(
        /eltesemiesemiesemiesemiesemiesemi/g,
        "eltesemiesemiesemiesemiesemiesemi;"
      )
      .replace(
        /pegtesemiesemiesemiesemiesemiesemi/g,
        "pegtesemiesemiesemiesemiesemiesemi;"
      )

      // Substituições para os valores com a barra "/"
      .replace(/\/eltesemi/g, "/eltesemi;")
      .replace(/\/pegtesemi/g, "/pegtesemi;")
      .replace(/\/eltesemiesemi/g, "/eltesemiesemi;")
      .replace(/\/pegtesemiesemi/g, "/pegtesemiesemi;")
      .replace(/\/eltesemiesemiesemi/g, "/eltesemiesemiesemi;")
      .replace(/\/pegtesemiesemiesemi/g, "/pegtesemiesemiesemi;")
      .replace(/\/eltesemiesemiesemiesemi/g, "/eltesemiesemiesemiesemi;")
      .replace(/\/pegtesemiesemiesemiesemi/g, "/pegtesemiesemiesemiesemi;")
      .replace(
        /\/eltesemiesemiesemiesemiesemi/g,
        "/eltesemiesemiesemiesemiesemi;"
      )
      .replace(
        /\/pegtesemiesemiesemiesemiesemi/g,
        "/pegtesemiesemiesemiesemiesemi;"
      )
      .replace(
        /\/eltesemiesemiesemiesemiesemiesemi/g,
        "/eltesemiesemiesemiesemiesemiesemi;"
      )
      .replace(
        /\/pegtesemiesemiesemiesemiesemiesemi/g,
        "/pegtesemiesemiesemiesemiesemiesemi;"
      )
  );
};

export const htmlDecode = (encodedText) => {
  console.log(encodedText);
  return encodedText
    .replace(/&amp;/g, "&")
    .replace(/&lt;/g, "<")
    .replace(/&gt;/g, ">")
    .replace(/&quot;/g, '"')
    .replace(/&#39;/g, "'")
    .replace(/&semi;/g, ";")
    .replace(/&colon;/g, ":")
    .replace(/elt;strongegt;/g, "<strong>")
    .replace(/elt;\/strongegt;/g, "</strong>")
    .replace(/elt;pegt;/g, "<p>")
    .replace(/elt;\/pegt;/g, "</p>")
    .replace(/elt;\/bregt;/g, "</b>")
    .replace(/elt;bregt;/g, "<br>")
    .replace(/elt;olegt;/g, "<ol>")
    .replace(/elt;liegt;/g, "<li>")
    .replace(/elt;\/liegt;/g, "</li>")
    .replace(/elt;\/olegt;/g, "</ol>")
    .replace(/\/?eltesemi;/g, " ")
    .replace(/\/?pegtesemi;/g, " ")
    .replace(/\/?strongegtesemiesemi;/g, " ")
    .replace(/\/?ulegtesemiesemi;/g, " ")
    .replace(/\/?liegtesemiesemi;/g, " ")
    .replace(/\/?emegtesemiesemi;/g, " ")
    .replace(/strongegtesemiesemi;/g, "<strong>")
    .replace(/\/strongegtesemiesemi;/g, "</strong>")
    .replace(/ulegtesemiesemi;/g, "<ul>")
    .replace(/\/ulegtesemiesemi;/g, "</ul>")
    .replace(/liegtesemiesemi;/g, "<li>")
    .replace(/\/liegtesemiesemi;/g, "</li>")
    .replace(/emegtesemiesemi;/g, "<em>")
    .replace(/\/emegtesemiesemi;/g, "</em>")
    .replace(/\/eltesemi;/g, "")
    .replace(/\/pegtesemi;/g, "")
    .replace(/\/eltesemiesemi;/g, "")
    .replace(/\/pegtesemiesemi;/g, "")
    .replace(/\/eltesemiesemiesemi;/g, "")
    .replace(/\/pegtesemiesemiesemi;/g, "")
    .replace(/\/eltesemiesemiesemiesemi;/g, "")
    .replace(/\/pegtesemiesemiesemiesemi;/g, "")
    .replace(/\/eltesemiesemiesemiesemiesemi;/g, "")
    .replace(/\/pegtesemiesemiesemiesemiesemi;/g, "")
    .replace(/\/eltesemiesemiesemiesemiesemiesemi;/g, "")
    .replace(/\/pegtesemiesemiesemiesemiesemiesemi;/g, "")
    .replace(/eltesemi;/g, "")
    .replace(/pegtesemi;/g, "")
    .replace(/eltesemiesemi;/g, "")
    .replace(/pegtesemiesemi;/g, "")
    .replace(/eltesemiesemiesemi;/g, "")
    .replace(/pegtesemiesemiesemi;/g, "")
    .replace(/eltesemiesemiesemiesemi;/g, "")
    .replace(/pegtesemiesemiesemiesemi;/g, "")
    .replace(/eltesemiesemiesemiesemiesemi;/g, "")
    .replace(/pegtesemiesemiesemiesemiesemi;/g, "")
    .replace(/eltesemiesemiesemiesemiesemiesemi;/g, "")
    .replace(/pegtesemiesemiesemiesemiesemiesemi;/g, "");
};
